import { render, staticRenderFns } from "./TipoExecucoesCadastrar.vue?vue&type=template&id=2b1e3184&scoped=true&"
import script from "./TipoExecucoesCadastrar.vue?vue&type=script&lang=js&"
export * from "./TipoExecucoesCadastrar.vue?vue&type=script&lang=js&"
import style0 from "./TipoExecucoesCadastrar.vue?vue&type=style&index=0&id=2b1e3184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e3184",
  null
  
)

export default component.exports